import { enumToOptions } from '@libs/types/src/common/enum/util';

export enum AccountingTypeEnum {
    SIMPLE = 'simple',
    DOUBLE = 'double',
}

export const accountingTypeOptions = enumToOptions(AccountingTypeEnum, 'organization-settings.mado.fiscalYear.accountingTypeOptions.');
